/// <returns>tagUser</returns>

var tagUser = (function () {
var bundle =

// modules are defined as an array
// [ module function, map of requireuires ]
//
// map of requireuires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the requireuire for previous bundles

(function() {

function outer(modules, cache, entry) {
    // Save the require from previous bundle to this closure if any
    var previousRequire = typeof require == "function" && require;

    function newRequire(name, jumped){
        if(!cache[name]) {
            if(!modules[name]) {
                // if we cannot find the module within our internal map or
                // cache jump to the current global require ie. the last bundle
                // that was added to the page.
                var currentRequire = typeof require == "function" && require;
                if (!jumped && currentRequire) return currentRequire(name, true);

                // If there are other bundles on this page the require from the
                // previous one is saved to 'previousRequire'. Repeat this as
                // many times as there are bundles until the module is found or
                // we exhaust the require chain.
                if (previousRequire) return previousRequire(name, true);
                var err = new Error('Cannot find module \'' + name + '\'');
                err.code = 'MODULE_NOT_FOUND';
                throw err;
            }
            var m = cache[name] = {exports:{}};
            modules[name][0].call(m.exports, function(x){
                var id = modules[name][1][x];
                return newRequire(id ? id : x);
            },m,m.exports,outer,modules,cache,entry);
        }
        return cache[name].exports;
    }
    for(var i=0;i<entry.length;i++) newRequire(entry[i]);

    // Override the current require with this new one
    return newRequire;
}

return outer;

})()
({1:[function(require,module,exports){
"use strict";

var forown = require("for-own");
var domEvent = require("dom-event");
var once = require("../lib/once");
var getOriginFromUrl = require("../lib/get-origin-from-url");
var jsonrpc = require("../lib/jsonrpc");
var objectAssign = require("object-assign");


function appendHashParams(url, params) {
	var parser = document.createElement("a");
	parser.href = url;
	url += parser.hash === "" ? "#" : "&";
	var args = [];
	forown(params, function (v, k) {
		var keyValue = encodeURIComponent(k) + "=" + encodeURIComponent(v);
		args.push(keyValue);
	});
	url += args.join("&");
	return url;
}

function createApiObject(call) {
	return {
		get: function (cb) {
			call("get", [], cb);
		},
		setQuarantine: function (quarantine, cb) {
			call("setQuarantine", [quarantine], cb);
		},
		setHasBackgroundInfo: function (hasBackgroundInfo, cb) {
			call("setHasBackgroundInfo", [hasBackgroundInfo], cb);
		},
		setDeviceId: function (deviceId, cb) {
			call("setDeviceId", [deviceId], cb);
		},
		clear: function (cb) {
			call("clear", [], cb);
		},
		store: {
			set: function (key, value, acl, cb) {
				call("store.set", [key, value, acl], cb);
			},
			get: function (key, cb) {
				call("store.get", [key], cb);
			},
			list: function (prefix, cb) {
				call("store.list", [prefix], cb);
			},
			attach: function (objarr, cb) {
				call("store.attach", [objarr], cb);
			}
		},
		userreport: {
			loadDataGeneral: function (cb) {
				call("userreport.loadDataGeneral", [], cb);
			},
			loadDataSite: function (websiteId, cb) {
				call("userreport.loadDataSite", [websiteId], cb);
			},
			sendQueueProcessorMessage: function (headers, parts, cb) {
				call("userreport.sendQueueProcessorMessage", [headers, parts], cb);
			}
		},
		relay: {
			send: function (url, payload, cb) {
				call("relay.send", [url, payload], cb);
			}
		}
	};
}

function appendIFrame(url) {
	var iframe = document.createElement("iframe");
	iframe.style.position = "absolute";
	iframe.style.width = "1px";
	iframe.style.height = "1px";
	iframe.style.top = "-1000px";
	iframe.style.left = "-1000px";
	iframe.style.visibility = "hidden";
	iframe.setAttribute("tabindex", "-1");
	iframe.setAttribute("title", "Empty");
	iframe.setAttribute("aria-hidden", "true");
	iframe.src = url;
	document.body.appendChild(iframe);
	return iframe;
}

module.exports = function (url, options, callback) {
	options = options || {};
	var defaultOptions = {
		suppressCookieSync: false
	};
	options = objectAssign(defaultOptions, options);

	var readyOnce = once(function (tagClient) {
		tagClient.get(function (err, state) {
			if (err) {
				callback(err, null, tagClient);
			}
			callback(null, {
				uid: state.info.deviceId
			}, tagClient);
		});
	});
	var origin = getOriginFromUrl(url);
	var responseRouter = jsonrpc.createResponseRouter();
	var instanceId = null;
	var iframe = null;
	var target = null;

	var maybeAppendIframeTimerId = null;

	var rpcCall = function (method, params, cb) {
		var id = responseRouter.add(cb);
		var json = jsonrpc.createRequest(id, method, params);
		target.postMessage(json, origin);
	};

	var maybeAppendIframe = function () {
		clearTimeout(maybeAppendIframeTimerId);

		if (target !== null) {
			// already loaded
			return;
		}
		if (iframe !== null) {
			// likely failed to load
			document.body.removeChild(iframe);
			iframe = null;
		}

		instanceId = String(Math.floor(Math.random() * 1000000));
		var frameParams = {
			instanceId: instanceId,
			dsu: options.dsu,
			origin: options.location || window.location.href.replace(/\/$/, ""),
			suppressCS: options.suppressCookieSync ? "1" : "-1"
		};
		var frameUrl = appendHashParams(url, frameParams);
		iframe = appendIFrame(frameUrl);

		// if frame fails to load
		maybeAppendIframeTimerId = setTimeout(maybeAppendIframe, 5000);
	};

	var isReadyEvent = function (event) {
		if (event.data === "APR-TAG-INITIALIZED") {
			return event.source === iframe.contentWindow;
		}
		else {
			var req = jsonrpc.parseRequest(event.data);
			return (
				req !== null && req.method === "ready" && req.params[0] === instanceId
			);
		}
	};

	domEvent(window, "message", function (event) {
		if (event.origin !== origin) {
			return;
		}

		if (target === null) {
			if (isReadyEvent(event)) {
				if (event.source) {
					target = event.source;
					readyOnce(createApiObject(rpcCall));
				}
				else {
					maybeAppendIframe();
				}
			}
			return;
		}

		if (event.source === target) {
			var res = jsonrpc.parseResponse(event.data);
			if (res !== null) {
				responseRouter.route(res);
			}
		}
	});

	maybeAppendIframe();
};

},{"../lib/get-origin-from-url":3,"../lib/jsonrpc":4,"../lib/once":5,"dom-event":6,"for-own":8,"object-assign":2}],2:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],3:[function(require,module,exports){
"use strict";

var parser = window.document.createElement("a");

module.exports = function (url) {
	parser.href = url;
	var protocol = parser.protocol;
	var port = String(parser.port);
	var hostname = parser.hostname;
	var stdProtoPort =
		port === "" ||
		(protocol === "https:" && port === "443") ||
		(protocol === "http:" && port === "80");

	return stdProtoPort
		? protocol + "//" + hostname
		: protocol + "//" + hostname + ":" + port;
};

},{}],4:[function(require,module,exports){
"use strict";

function createResponseRouter() {
	var shift = Math.floor(Math.random() * 1000000);
	var callbacks = [];

	var add = function (callback) {
		var index = callbacks.push(callback) - 1;
		var id = String(shift + index);
		return id;
	};

	var route = function (res) {
		var index = parseInt(res.id) - shift;
		var callback = callbacks[index];
		delete callbacks[index];
		if (callback) {
			callback(res.error, res.result);
		}
	};

	return { add: add, route: route };
}

function createRequest(id, method, params) {
	if (id !== null) {
		return JSON.stringify({
			jsonrpc: "2.0",
			id: id,
			method: method,
			params: params
		});
	}
	else {
		return JSON.stringify({
			jsonrpc: "2.0",
			method: method,
			params: params
		});
	}
}

function parseResponse(json) {
	try {
		var res = JSON.parse(json);
		if (res.jsonrpc !== "2.0" || !res.id) {
			return null;
		}
		if (!res.hasOwnProperty("result") && !res.hasOwnProperty("error")) {
			return null;
		}
		res.error = res.error || null;
		return res;
	}
	catch (err) {
		return null;
	}
}

function parseRequest(json) {
	try {
		var req = JSON.parse(json);
		if (req.jsonrpc !== "2.0" || !req.method || !req.params) {
			return null;
		}
		req.id = req.id || null;
		return req;
	}
	catch (err) {
		return null;
	}
}

function createResponse(id, err, result) {
	if (err) {
		return JSON.stringify({
			jsonrpc: "2.0",
			id: id,
			error: { code: err.code || 1000, message: err.message }
		});
	}
	else {
		return JSON.stringify({
			jsonrpc: "2.0",
			id: id,
			result: typeof result !== "undefined" ? result : null
		});
	}
}

function createRequestCallback(req, send) {
	if (req.id === null) {
		return function () { /* noop */ };
	}

	return function (err, result) {
		var json = createResponse(req.id, err, result);
		send(json);
	};
}

exports.createResponseRouter = createResponseRouter;
exports.createRequest = createRequest;
exports.parseResponse = parseResponse;

exports.parseRequest = parseRequest;
exports.createResponse = createResponse;
exports.createRequestCallback = createRequestCallback;

},{}],5:[function(require,module,exports){
"use strict";

module.exports = function (fn) {
	var called = false;
	var result = null;

	return function () {
		if (called) {
			return result;
		}
		called = true;
		result = fn.apply(this, arguments); // eslint-disable-line no-invalid-this
		return result;
	};
};

},{}],6:[function(require,module,exports){
module.exports = on;
module.exports.on = on;
module.exports.off = off;

function on (element, event, callback, capture) {
  !element.addEventListener && (event = 'on' + event);
  (element.addEventListener || element.attachEvent).call(element, event, callback, capture);
  return callback;
}

function off (element, event, callback, capture) {
  !element.removeEventListener && (event = 'on' + event);
  (element.removeEventListener || element.detachEvent).call(element, event, callback, capture);
  return callback;
}

},{}],7:[function(require,module,exports){
/*!
 * for-in <https://github.com/jonschlinkert/for-in>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

module.exports = function forIn(obj, fn, thisArg) {
  for (var key in obj) {
    if (fn.call(thisArg, obj[key], key, obj) === false) {
      break;
    }
  }
};

},{}],8:[function(require,module,exports){
/*!
 * for-own <https://github.com/jonschlinkert/for-own>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

var forIn = require('for-in');
var hasOwn = Object.prototype.hasOwnProperty;

module.exports = function forOwn(obj, fn, thisArg) {
  forIn(obj, function(val, key) {
    if (hasOwn.call(obj, key)) {
      return fn.call(thisArg, obj[key], key, obj);
    }
  });
};

},{"for-in":7}]},{},[1]);
return bundle(1);
})()